module.exports = __webpack_public_path__ + "img/nolan-lightning-bolt.e6542e54.svg";